import React, { useState } from 'react';
// Comment out Resend for now - it requires a backend
// import { sendContactEmail } from '../services/resendEmail';
import { sendContactEmail } from '../services/emailjs';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    address: '',
    projectType: '',
    message: '',
    smsConsent: false,
    marketingConsent: false
  });

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === 'checkbox' ? checked : value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await sendContactEmail(formData);
      alert('Thank you for your inquiry! We will contact you within 24 hours.');
      setFormData({
        name: '',
        email: '',
        phone: '',
        address: '',
        projectType: '',
        message: '',
        smsConsent: false,
        marketingConsent: false
      });
    } catch (error) {
      console.error(error);
      alert('Sorry, something went wrong while sending your message. Please try again later.');
    }
  };

  return (
    <section id="contact" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-wood-dark mb-4">
            Get Your Free Quote Today
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            Contact us for a free consultation and estimate on your hardwood flooring project
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
          {/* Contact Form */}
          <div className="bg-white rounded-xl shadow-lg p-8">
            <form onSubmit={handleSubmit} className="space-y-6">
              <div>
                <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-2">
                  Full Name *
                </label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  required
                  value={formData.name}
                  onChange={handleChange}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-wood-brown focus:border-transparent"
                  placeholder="John Smith"
                />
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                  <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-2">
                    Email *
                  </label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    required
                    value={formData.email}
                    onChange={handleChange}
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-wood-brown focus:border-transparent"
                    placeholder="john@example.com"
                  />
                </div>
                <div>
                  <label htmlFor="phone" className="block text-sm font-medium text-gray-700 mb-2">
                    Phone *
                  </label>
                  <input
                    type="tel"
                    id="phone"
                    name="phone"
                    required
                    value={formData.phone}
                    onChange={handleChange}
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-wood-brown focus:border-transparent"
                    placeholder="913-538-8541"
                  />
                </div>
              </div>

              <div>
                <label htmlFor="address" className="block text-sm font-medium text-gray-700 mb-2">
                  Property Address
                </label>
                <input
                  type="text"
                  id="address"
                  name="address"
                  value={formData.address}
                  onChange={handleChange}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-wood-brown focus:border-transparent"
                  placeholder="123 Main St, Kansas City, MO"
                />
              </div>

              <div>
                <label htmlFor="projectType" className="block text-sm font-medium text-gray-700 mb-2">
                  Project Type *
                </label>
                <select
                  id="projectType"
                  name="projectType"
                  required
                  value={formData.projectType}
                  onChange={handleChange}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-wood-brown focus:border-transparent"
                >
                  <option value="">Select a project type</option>
                  <option value="new-installation">New Hardwood Installation</option>
                  <option value="refinishing">Floor Refinishing</option>
                  <option value="repair">Floor Repair</option>
                  <option value="lvt-installation">LVT Installation</option>
                  <option value="tear-out">Complete Tear-Out & Replace</option>
                  <option value="other">Other</option>
                </select>
              </div>

              <div>
                <label htmlFor="message" className="block text-sm font-medium text-gray-700 mb-2">
                  Project Details
                </label>
                <textarea
                  id="message"
                  name="message"
                  rows={4}
                  value={formData.message}
                  onChange={handleChange}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-wood-brown focus:border-transparent"
                  placeholder="Tell us about your project..."
                />
              </div>

              {/* SMS Consent Checkbox */}
              <div className="bg-gray-50 p-4 rounded-lg border border-gray-200">
                <label className="flex items-start cursor-pointer">
                  <input
                    type="checkbox"
                    name="smsConsent"
                    required
                    checked={formData.smsConsent}
                    onChange={handleChange}
                    className="mt-1 h-5 w-5 text-wood-brown border-gray-300 rounded focus:ring-wood-brown flex-shrink-0"
                  />
                  <span className="ml-3 text-sm text-gray-600">
                    <span className="text-gray-800 font-medium">SMS Consent *</span><br />
                    By providing your phone number, you agree to receive text messages from Easy Floor KC regarding scheduling and estimates. Message & data rates may apply. Message frequency varies. Reply STOP to opt out. Reply HELP for help.
                  </span>
                </label>
              </div>

              {/* Marketing Consent Checkbox */}
              <div className="bg-gray-50 p-4 rounded-lg border border-gray-200">
                <label className="flex items-start cursor-pointer">
                  <input
                    type="checkbox"
                    name="marketingConsent"
                    required
                    checked={formData.marketingConsent}
                    onChange={handleChange}
                    className="mt-1 h-5 w-5 text-wood-brown border-gray-300 rounded focus:ring-wood-brown flex-shrink-0"
                  />
                  <span className="ml-3 text-sm text-gray-600">
                    <span className="text-gray-800 font-medium">Marketing Consent *</span><br />
                    By checking this box, I consent to receive marketing and promotional messages, including special offers, discounts, new product updates among others. Message frequency may vary. Message & Data rates may apply. Reply HELP for help or STOP to opt-out.
                  </span>
                </label>
              </div>

              <button
                type="submit"
                className="w-full bg-wood-brown hover:bg-wood-dark text-white font-bold py-4 px-6 rounded-lg transition duration-300 transform hover:scale-105"
              >
                Get Free Quote
              </button>
            </form>
          </div>

          {/* Contact Information */}
          <div>
            <div className="bg-wood-brown rounded-xl p-8 text-white mb-8">
              <h3 className="text-2xl font-bold mb-6">Contact Information</h3>
              <div className="space-y-4">
                <div className="flex items-start">
                  <svg className="w-6 h-6 mr-3 mt-1" fill="currentColor" viewBox="0 0 20 20">
                    <path d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z" />
                  </svg>
                  <div>
                    <p className="font-semibold">Call Us</p>
                    <p>913-538-8541</p>
                  </div>
                </div>
                <div className="flex items-start">
                  <svg className="w-6 h-6 mr-3 mt-1" fill="currentColor" viewBox="0 0 20 20">
                    <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z" />
                    <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z" />
                  </svg>
                  <div>
                    <p className="font-semibold">Email</p>
                    <p>thiago@easyfloorkc.com</p>
                  </div>
                </div>
                <div className="flex items-start">
                  <svg className="w-6 h-6 mr-3 mt-1" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z" clipRule="evenodd" />
                  </svg>
                  <div>
                    <p className="font-semibold">Service Area</p>
                    <p>Greater Kansas City Metro</p>
                  </div>
                </div>
              </div>
            </div>

            <div className="bg-gray-100 rounded-xl p-8">
              <h3 className="text-2xl font-bold text-wood-dark mb-4">Business Hours</h3>
              <div className="space-y-2 text-gray-700">
                <div className="flex justify-between">
                  <span>Monday - Friday</span>
                  <span>8:00 AM - 6:00 PM</span>
                </div>
                <div className="flex justify-between">
                  <span>Saturday</span>
                  <span>9:00 AM - 4:00 PM</span>
                </div>
                <div className="flex justify-between">
                  <span>Sunday</span>
                  <span>Closed</span>
                </div>
              </div>
              <p className="mt-4 text-sm text-gray-600">
                Emergency services available 24/7 for water damage
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
